import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, matchRoutes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Planner from './pages/Planner';

import { useEffect } from 'react';
import { MapViewer } from './components/MapViewer';
import Admin from './pages/Admin';
import { PanoramaViewer } from './components/PanoramaViewer';
import { SolarViewer } from './components/SolarViewer';
import Docs from './components/docs/Docs';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
    },
  },
});

const App = () => {
  const routes = [{ path: '/:company/:sitename/:view?' }];

  const route = matchRoutes(routes, location);

  const company = route ? route[0].params.company : '';

  useEffect(() => {
    if (company) {
      const cssFilePath = `/styles/${company}5.css?v=112`;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssFilePath;
      document.head.appendChild(link);
    }
  }, [company]);

  const RedirectWithReload = () => {
    window.location.href = '/svenskhusproduktion/Gåvsta';
    return null;
  };

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<RedirectWithReload />} />

          <Route path="/:company/:sitename/" element={<Planner />} />
          <Route path="/:company/:sitename/map" element={<MapViewer />} />
          <Route path="/:company/:sitename/solar" element={<SolarViewer />} />
          <Route path="/:company/:sitename/panorama" element={<PanoramaViewer fullscreen />} />
          <Route path="/:company/docs" element={<Docs />} />
          <Route path="/:company/admin" element={<Admin />} />
          <Route path="/:company/admin/:sitename" element={<Admin />} />
        </Routes>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

const container = document.getElementById('root');
if (!container) {
  throw new Error('no container to render to');
}

const root = createRoot(container);
root.render(<App />);
